module.exports = __webpack_public_path__ + "static/media/didi looking.adab5875.gif";